//Context menu for editing edge text.

import { useState, useEffect} from 'react';
import './editedge.css';

function EditEdge({submitEdge, position, offset, isToggled, closeDialog}) {
    const [edgeLabel, setEdgeLabel] = useState("");

    const topPos = position.y + offset.y;
    const leftPos = position.x + offset.x;

    function handleLabelChange(event)
    {
        setEdgeLabel(event.target.value);
    }

    function addCharacter(character)
    {
      setEdgeLabel(edgeLabel + character);
    }

  return (
    <div className='editedge' style={{top:`${topPos}px`, left:`${leftPos}px`, visibility:isToggled ? 'visible' : 'hidden'}} >
      <div className='editedge-letterbuttons'>
        <button className='editedge-button' onClick={() => addCharacter("α")}>α</button>
        <button className='editedge-button' onClick={() => addCharacter("β")}>β</button>
      </div>
      
      <input onChange={handleLabelChange} value={edgeLabel}></input>
      <button className='editedge-button' onClick={() => {submitEdge(edgeLabel);closeDialog();setEdgeLabel("")}}>Apply</button>
      <button className='editedge-button' onClick={closeDialog}>Cancel</button>
    </div>
  );
}

export default EditEdge;